import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth.js";

function AdminGuard({ children }) {
  const { tipo } = useAuth();

  if (tipo !== 1) {
    return <Navigate to="/" replace />;
  }

  return <React.Fragment>{children}</React.Fragment>;
}

export default AdminGuard;
